import { useEffect, useState } from "react";
import {
  getCityApi,
  getCountryApi,
  getStateApi,
} from "../../../services/apis/EventMangement/CountryStateCityApi";
import MyMapComponent from "../common/MyMapComponent";
import BtnLoader from "../Loader/BtnLoader";
import { toast, ToastContainer } from "react-toastify";
import { CreateAgencyBasicInfoApi, CreateAgencyCompanyAddressApi } from "../../../services/apis/Agency";
import Swal from "sweetalert2";
import { getLatLngApi } from "../../../services/apis/LatLongWithPin";

const CompanyAddress = ({ agencyId,setTabValue }) => {
  const [inputData, setInputData] = useState({
    country: "",
    state: "",
    city: "",
    zipcode: "",
    address: "",
  });
  const [errors, setErrors] = useState({});
  const [countriesList, setCountriesList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [coordinates, setCoordinates] = useState({ lat: "", lon: "" });

  const fetchLatLon = async (zipcode) => {
    try {
      const response = await getLatLngApi(zipcode);
      const data = await response?.data;
      if (data?.length > 0) {
        setCoordinates({ lat: data[0].lat, lon: data[0].lon });
      } else {
        setCoordinates({ lat: "", lon: "" });
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
      setErrors((prev) => ({ ...prev, zipcode: "Failed to fetch location" }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
    if (name === "zipcode") {
      fetchLatLon(value);
    }
  };

  const fetchInitialData = async () => {
    try {
      const countriesResponse = await getCountryApi();
      setCountriesList(countriesResponse.data?.countries);

      if (inputData?.country) {
        const statesResponse = await getStateApi(inputData.country);
        setStateList(statesResponse?.data?.states);
      }

      if (inputData?.state) {
        const citiesResponse = await getCityApi(
          inputData.country,
          inputData.state
        );
        setCityList(citiesResponse?.data?.cities);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, [inputData?.country, inputData?.state]);

  const fetchData = async () => {
    try {
      const response = await getCityApi(inputData?.country, inputData?.state);
      setCityList(response?.data?.cities);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (inputData?.state) {
      fetchData();
    }
  }, [inputData?.state]);

  const validate = () => {
    const newErrors = {};

    // Validate country
    if (!inputData?.country?.trim()) {
      newErrors.country = "Country is required.";
    }

    // Validate state
    if (!inputData?.state?.trim()) {
      newErrors.state = "State is required.";
    }

    // Validate city
    if (!inputData?.city?.trim()) {
      newErrors.city = "City is required.";
    }

    // Validate zip code
    if (!inputData?.zipcode?.trim()) {
      newErrors.zipcode = "Zip code is required.";
    }

    // Validate address
    if (!inputData?.address?.trim()) {
      newErrors.address = "Address is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  console.log("errr",errors)

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      const { confirm_password, ...dataToSend } = inputData;
      try {
        const response = await CreateAgencyCompanyAddressApi(agencyId,dataToSend);
        const resData = response?.data;
        // Simulate API request
        if (resData?.success) {
            Swal.fire({
              icon: "success",
              title: "Agency",
              text: resData?.message,
            });
          toast.success(resData?.message);
          setInputData({
            country: "",
            state: "",
            city: "",
            zipcode: "",
            address: "",
          });
          setTabValue("Social-Handles");
        }
      } catch (error) {
        console.log("Error", error);
        toast.error(error?.response?.data?.message);
      } finally {
        setBtnLoading(false);
      }
    }
  };

  return (
    <>
      <ToastContainer />
      <div className=" profile-card card-bx ">
        <form onSubmit={handleSubmit}>
          <div className="">
            <div className="mb-3 row">
              <div className="col-sm-3">
                <label className="col-sm-4 col-form-label">
                  Country<span className="asterisk">*</span>
                </label>

                <select
                  className="form-control"
                  name="country"
                  onChange={handleInputChange}
                >
                  <option>Select Country</option>
                  {countriesList.map((value) => (
                    <option
                      value={value?.id}
                      selected={value?.id == inputData?.country}
                    >
                      {value?.name}
                    </option>
                  ))}
                </select>
                {errors.country && (
                  <small className="text-danger">{errors.country}</small>
                )}
              </div>

              <div className="col-sm-3">
                <label className="col-sm-4 col-form-label">
                  State<span className="asterisk">*</span>
                </label>

                <select
                  className="form-control"
                  name="state"
                  onChange={handleInputChange}
                >
                  <option>Select State</option>
                  {stateList.map((value) => (
                    <option value={value?.id}>{value?.name}</option>
                  ))}
                </select>
                {errors.state && (
                  <small className="text-danger">{errors.state}</small>
                )}
              </div>

              <div className="col-sm-3">
                <label className="col-sm-4 col-form-label">
                  City<span className="asterisk">*</span>
                </label>
                <select
                  className="form-control"
                  name="city"
                  onChange={handleInputChange}
                >
                  <option>Select City</option>
                  {cityList.map((value) => (
                    <option value={value?.id}>{value?.name}</option>
                  ))}
                </select>

                {errors.city && (
                  <small className="text-danger">{errors.city}</small>
                )}
              </div>

              <div className="col-sm-3">
                <label className="col-sm-4 col-form-label">
                  Pin Code<span className="asterisk">*</span>
                </label>
                <input
                  name="zipcode"
                  value={inputData.zipcode}
                  onChange={handleInputChange}
                  type="number"
                  className="form-control"
                  placeholder="Ex: 123456"
                  maxLength={12}
                />
                {errors.zipcode && (
                  <small className="text-danger">{errors.zipcode}</small>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-sm-6">
                <label className="col-sm-6 col-form-label">
                  Street Address<span className="asterisk">*</span>
                </label>
                <textarea
                  name="address"
                  value={inputData.address}
                  onChange={handleInputChange}
                  className="form-control"
                  rows="3"
                  placeholder="Ex: ABC"
                  maxLength={300}
                />
                {errors.address && (
                  <small className="text-danger">{errors.address}</small>
                )}
              </div>
            </div>

            <div className="mt-4">
              <MyMapComponent coordinates={coordinates}/>
            </div>

            <div className="d-flex justify-content-end gap-4 mt-4">
              <div className="">
                <button className="btn btn-outline-primary" type="button" 
                 onClick={()=>setTabValue("Social-Handles")}>Skip</button>
              </div>
              <div className="">
                <button className="btn btn-primary" type="submit">
                  {btnLoading && <BtnLoader />} Save and continue
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default CompanyAddress;
